import $ from 'jquery';
import Item from './item';
import JsonUrl from './json-url';


class Cart {

	constructor() {
		var
			indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB,
			request = indexedDB.open('balu', 1),
			data = (window.location.search.split('data=')[1] || '').split('&')[0]
		;

		this.jsonUrl = new JsonUrl();
		this.$items = $('#items');

		request.onupgradeneeded = () => {
			var
				db = request.result,
				store = db.createObjectStore('items', {keyPath: 'name'})
			;

			store.createIndex('name', 'name', {unique: true});
		};

		request.onsuccess = () => {
			this.item = new Item({
				db: request.result
			});

			if (data) {
				this.parseJSON(data).then((json) => {
					// Clear item storage
					this.item.clear();

					// Parse JSON
					this.data = json;
					json.forEach((item) => this.setItem(item.name));
				}, () => this.getItems());
			} else {
				this.getItems()
			}
		};

		this.events();
	}

	showItem(name, prepend) {
		var
			$children = this.$items.children(),
			$item
		;

		if (name && !$children.filter(function() {
			return ($(this).contents().get(0).nodeValue === name);
		}).length) {
			$item = $(
				'<li class="collection-item">' + name +
				'<a href="#" class="secondary-content"><i class="material-icons">clear</i></a></li>'
			).hide();

			if (prepend) {
				$item.prependTo(this.$items);
			} else {
				$item.appendTo(this.$items);
			}

			$item.fadeIn('fast');
		}
	}

	getItems(show = true) {
		this.item.getAll().then((items) => {
			// Show items
			if (show) {
				items.forEach((item) => {
					this.showItem(item.name);
				});
			}

			// Update data and rewrite url
			this.data = items;
			this.getUrl(items);
		})
	}

	setItem(item, prepend) {
		this.item.add(item).then((name) => {
			this.showItem(name, prepend);
		});
	}

	getUrl(items) {
		var params = (items && items.length) ? '?data=' + this.jsonUrl.encode(items) : '';
		return window.history.pushState('', document.title, window.location.pathname + params);
	}

	parseJSON(data) {
		return new Promise((resolve) => {
			try {
				resolve(this.jsonUrl.decode(data));
			} catch(e) {
				// window.console.log(e);
			}
		});
	}

	events() {

		/**
		 * Add single item
		 * @param  {Object} event
		 */
		$('#add').on('submit', (event) => {
			event.preventDefault();

			var
				$el = $('#name'),
				item = $el.val()
			;

			this.item.add(item).then((name) => {
				$el.val('');
				this.showItem(name, true)
				this.getItems(false);
			});
		});

		/**
		 * Add multiple items
		 */
		$('#many').on('click', () => {
			var
				$el = $('#text'),
				items = $el.val().split(/[\n,]/g)
			;

			Promise.all(items.map((item) => this.setItem(item, true))).then(() => {
				$el.val('');
				this.getItems(false);
			});
		});

		/**
		 * Remove item
		 */
		this.$items.on('click', '.secondary-content', (event) => {
			event.preventDefault();

			var
				$el = $(event.currentTarget).closest('li'),
				item = $el.contents().get(0).nodeValue
			;

			this.item.delete(item).then(() => {
				$el.remove();
				this.getItems(false);
			});
		});

		/**
		 * Clear items
		 * @param  {Object} clear
		 */
		$('#clear').on('click', (event) => {
			event.preventDefault();
			this.item.clear();
			this.getUrl();
			this.$items.html('');
		});

		/**
		 * Undo clear items
		 */
		$('body').on('click', '#undo-clear', () => {
			if (!this.data) {
				return;
			}

			// Revert items
			this.data.forEach((item) => this.setItem(item.name));

			// Revert url
			this.getUrl(this.data);
		});
	}

}

export default Cart;



// WEBPACK FOOTER //
// ./src/js/modules/cart.js